import { useQuery } from 'react-query';
import { fetchRoles } from 'utils/api';

export const useRoles = () => {
  return useQuery('roles', () => fetchRoles(), {
    staleTime: 120000,
  });
};
